const webarSceneComponent = {
  init: function () {
    const video = document.createElement('video');
    video.autoplay = true;
    video.id = 'webcam';
    video.muted = true;
    video.setAttribute('playsinline', 'true');
    // video.style.width = '640px';
    // video.style.height = '480px';

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: 'environment',
          // width: { ideal: 640 },
          // height: { ideal: 480 },
        },
      })
      .then(stream => {
        // Find the video element
        // Set the video source to the stream
        video.srcObject = stream;
      })
      .catch(() => {
        //
      });
    const markerlessEle = document.getElementById('markerless');
    if (markerlessEle) markerlessEle.appendChild(video);
  },
};

export default webarSceneComponent;

// ARjs
// <canvas class="a-canvas a-grab-cursor" data-aframe-canvas="true" data-engine="three.js r173" width="2796" height="2097" style=""></canvas>
